import { createSlice } from '@reduxjs/toolkit';
import axios from 'axios';
import { buildPermissionsMap } from './Components/Utils/UtilityFunctions';

const initialState = {
  permissions: [],
  permissionsMap: [],
  loading: false,
  error: null,
};

const permissionsSlice = createSlice({
  name: 'permissions',
  initialState,
  reducers: {
    fetchPermissionsStart: (state) => {
      state.loading = true;
      state.error = null;
    },
    fetchPermissionsSuccess: (state, action) => {
      state.loading = false;
      state.permissions = action.payload;
    },
    fetchPermissionsFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    setPermissionsMap: (state, action) => {
      state.permissionsMap = action.payload
    }
  },
});

export const {
  fetchPermissionsStart,
  fetchPermissionsSuccess,
  fetchPermissionsFailure,
  setPermissionsMap
} = permissionsSlice.actions;

export const fetchPermissions = () => async (dispatch) => {
  dispatch(fetchPermissionsStart());
  try {
    const bearerToken = localStorage.getItem('token');
    const response = await axios.get(
      `${window.env.REACT_APP_PERMISSIONS_API}`,
      {
        headers: {
          Authorization: `Bearer ${bearerToken}`,
        },
      }
    );
    dispatch(fetchPermissionsSuccess(response.data));
    const permissions = Array.from(buildPermissionsMap(response?.data?.modules).entries()).map(
      ([key, value]) => {
        return [key, Array.from(value)];
      }
    );
    dispatch(setPermissionsMap(permissions));
  } catch (error) {
    dispatch(fetchPermissionsFailure(error.message));
  }
};

export default permissionsSlice.reducer;
